var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12656_21112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18V1H0.5V18H17.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12656_21112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98438 13.7172C7.46588 16.1435 9.60608 17.9727 12.1738 17.9727C13.2355 17.9727 14.2239 17.6597 15.0525 17.1214L17.2105 17.7183L16.6136 15.5603C17.1519 14.7318 17.4648 13.7433 17.4648 12.6816C17.4648 10.1139 15.6357 7.97373 13.2094 7.49223",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87305 1.02734C3.36843 1.02734 0.527344 3.86843 0.527344 7.37305C0.527344 8.62946 0.892582 9.80055 1.52251 10.7861L0.781699 13.4644L3.46004 12.7236C4.44558 13.3535 5.61663 13.7188 6.87305 13.7188C10.3777 13.7188 13.2188 10.8777 13.2188 7.37305C13.2188 3.86843 10.3777 1.02734 6.87305 1.02734Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84375 10.5273V10.582H6.89844V10.5273H6.84375Z",
    fill: "white",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29297 5.77344C5.29297 4.8997 6.00126 4.19141 6.875 4.19141C7.74874 4.19141 8.45703 4.8997 8.45703 5.77344C8.45703 6.23574 8.25864 6.65168 7.94245 6.94091L6.875 7.91797V8.97266",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHelpIcon);
export default __webpack_public_path__ + "static/media/menu-help-icon.0ed05af7503bd04b5003ed7361c345a7.svg";
export { ForwardRef as ReactComponent };